import React from 'react';
import { useTranslation } from 'react-i18next';

// Builds a compact page list: 1 … 4 5 6 … 20
const buildPages = (page, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages = [1];
  if (page > 3) pages.push('gap-start');

  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  for (let i = start; i <= end; i++) pages.push(i);

  if (page < totalPages - 2) pages.push('gap-end');
  pages.push(totalPages);
  return pages;
};

const Pagination = ({ page, totalPages, totalCount, pageSize, onChange }) => {
  const { t } = useTranslation();

  if (!totalPages || totalPages < 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount ?? page * pageSize);

  return (
    <div className="ad-pagination">
      <span className="ad-pagination-info">
        {totalCount != null
          ? t('common.showingResults', { from, to, total: totalCount })
          : t('common.pageOf', { page, total: totalPages })}
      </span>

      {totalPages > 1 && (
        <div className="ad-pagination-pages">
          <button
            className="ad-page-btn"
            onClick={() => onChange(page - 1)}
            disabled={page === 1}
            title={t('common.previous')}
          >
            {t('common.previous')}
          </button>

          {buildPages(page, totalPages).map((p) =>
            typeof p === 'number' ? (
              <button
                key={p}
                className={`ad-page-btn ${p === page ? 'ad-page-btn-active' : ''}`}
                onClick={() => onChange(p)}
              >
                {p}
              </button>
            ) : (
              <span key={p} className="ad-page-gap">…</span>
            )
          )}

          <button
            className="ad-page-btn"
            onClick={() => onChange(page + 1)}
            disabled={page === totalPages}
            title={t('common.next')}
          >
            {t('common.next')}
          </button>
        </div>
      )}
    </div>
  );
};

export default Pagination;
